import React, { useEffect, useState } from "react";
import axios from "axios";
import ListaCitasProfesor from "./ListaCitasProfesor";
import API from "../config";

const ProfesorPanel = ({ usuario, onLogout, colorFondoGlobal }) => {
  const [profesorId, setProfesorId] = useState(null);

  // 🔥 OBTENER ID REAL DEL PROFESOR
  useEffect(() => {
    const obtenerProfesor = async () => {
      try {
        const res = await axios.get(
          `${API}/api/profesores/por-usuario/${usuario.id}`
        );

        console.log("Profesor encontrado:", res.data);
        setProfesorId(res.data.id);

      } catch (error) {
        console.error("Error obteniendo profesor:", error);
      }
    };

    obtenerProfesor();
  }, [usuario.id]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colorFondoGlobal,
        fontFamily: "'Poppins', sans-serif",
        boxSizing: "border-box",
        padding: "30px 15px",
      }}
    >
      {/* Encabezado */}
      <div
        style={{
          boxSizing: "border-box",
          backgroundColor: "#1e3a8a",
          color: "white",
          width: "100%",
          maxWidth: "900px",
          margin: "0 auto 25px",
          borderRadius: "16px",
          padding: "25px 20px",
          textAlign: "center",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "24px" }}>
          👋 Bienvenido, <span style={{ fontWeight: "600" }}>{usuario.nombre}</span>
        </h2>
        <p style={{ fontSize: "15px", opacity: 0.9 }}>
          Panel del profesor — gestión de citas con padres
        </p>
      </div>

      {/* Botón logout */}
      <div style={{ width: "100%", maxWidth: "900px", margin: "0 auto 30px", textAlign: "center" }}>
        <button
          onClick={onLogout}
          style={{
            backgroundColor: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "10px",
            padding: "10px 20px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "500",
            boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          }}
        >
          🔒 Cerrar sesión
        </button>
      </div>

      {/* Sección citas */}
      <div
        style={{
          boxSizing: "border-box",
          width: "100%",
          maxWidth: "900px",
          margin: "0 auto",
          background: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          padding: "25px",
        }}
      >
        <h3
          style={{
            color: "#1e3a8a",
            marginBottom: "20px",
            fontSize: "20px",
            borderBottom: "2px solid #1e3a8a",
            paddingBottom: "8px",
          }}
        >
          📅 Mis Citas Agendadas
        </h3>

        {/* 👇 AHORA SÍ SE ENVÍA EL ID CORRECTO */}
        {profesorId ? (
          <ListaCitasProfesor profesorId={profesorId} />
        ) : (
          <p>Cargando citas...</p>
        )}
      </div>

      <footer style={{ marginTop: "40px", color: "#6b7280", fontSize: "13px" }}>
        © {new Date().getFullYear()} CitasApp — Todos los derechos reservados
      </footer>
    </div>
  );
};

export default ProfesorPanel;
